import React, { useEffect, useState, useContext } from "react";
import DataTable from "../Student/Reusablecomponents/DataTable/DataTable";
import axiosInstance from "../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import { LoadContext } from "../ReusableComponents/LoadingContex";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";

const CurrentAssessmentparticipation = () => {
    const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const { SetLoad } = useContext(LoadContext);
    const [ATTOptions, SetATTOptions] = useState();
    const [APCounts, SetAPCounts] = useState([]);
    const CurrentAssessmentDetails = async () => {
        SetLoad(true);
        try {
            const res = await axiosInstance.get(`/InstitutionAdmin/GetLatestAssessmentsSchedulesbyInstitute?InstituteId=${items?.instituteId}&SocietyId=${(items?.instituteId === 8 || items?.instituteId === 9) ? items?.societyId : 0}`);
            if (res.data[0]?.contestCreationId) {
                GetAssessmentsParticipationcount(res.data[0]?.contestCreationId, res.data[0]?.assessmentType, res.data[0]?.assessmentTypeNo);
                const FormatData = res.data.map((item) => ({
                    display: `${item?.assessmentTypeName} , ${item?.assessmentDate}`,
                    value: item?.contestCreationId,
                    ...item
                }))
                SetATTOptions(FormatData)
            } else {
                SetLoad(false);
            }
        }
        catch (err) { console.log(err) }
    }
    useEffect(() => { CurrentAssessmentDetails(); }, [])
    const HandleAssessmentChange = (e) => {
        const SA = ATTOptions.filter((item) => item.value == e.target.value);
        SetLoad(true);
        GetAssessmentsParticipationcount(SA?.[0]?.contestCreationId, SA?.[0]?.assessmentType, SA?.[0]?.assessmentTypeNo);
    }
    const GetAssessmentsParticipationcount = async (CCID, AType, ATNo) => {
        try {
            const res = await axiosInstance.get(`/Principal/GetSchoolWiseAssessmentParticipation?Contestcreationid=${CCID}&Schoolid=${items?.schoolId}&InstituteId=${items?.instituteId}&AssessmentType=${AType}&SocietyId=${ items?.instituteId === 1 ? 0 : items?.societyId || 0}`)
            if (res.data?.length > 0) {
                const Totals = res.data.reduce(
                    (acc, item) => {
                        acc.participationCount += item.participationCount;
                        acc.registeredCount += item.registeredCount;
                        return acc;
                    },
                    { participationCount: 0, registeredCount: 0 }
                );
                const Total = { grade: "Total", ...Totals }
                SetAPCounts([...res.data, Total]);
            } else {
                SetAPCounts([]);
            }
            SetLoad(false);
        }
        catch (err) { console.log(err) }
    }

    const columns = [
        {
            name: "Grade", selector: "grade", sortable: true,
            cell: (row) => (<div>{row.grade === "Total" ? <b>{row.grade}</b> : row.grade} </div>),

        },
        { name: "Registered", selector: "registeredCount", sortable: true, },
        { name: "Participation", selector: "participationCount", sortable: true, },
    ];
    return (
        <>
            <div className="MainHeading">Live Assessment Participation</div>
            <div className="dflex alignitems JSBetween mt-1">
                <div></div>
                <DropdownValues className="NCLDropdown" options={ATTOptions} onChange={(e) => HandleAssessmentChange(e)} />
            </div>
            <DataTable className="NCLDataTable mt-3" data={APCounts} columns={columns} Dropdownvalues={["15"]} DisplaySearch={true} />
        </>
    )
}
export default CurrentAssessmentparticipation;